module.exports = require("./lib/polyfill");



//////////////////
// WEBPACK FOOTER
// ./~/babel-core/polyfill.js
// module id = 78
// module chunks = 0